import { render, staticRenderFns } from "./PhoneValidate2.vue?vue&type=template&id=3704069c&scoped=true&"
import script from "./PhoneValidate2.vue?vue&type=script&lang=js&"
export * from "./PhoneValidate2.vue?vue&type=script&lang=js&"
import style0 from "./PhoneValidate2.vue?vue&type=style&index=0&id=3704069c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3704069c",
  null
  
)

export default component.exports